import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { toast } from "react-toastify";
import { fetchInstrumentMethods } from "../../../../actions/chemistry";

const DashboardInstrumentTable = () => {
  const [dataSource, setDataSource] = useState([]);

  const columns = [
    {
      title: "Brand",
      dataIndex: "instrument_brand",
      key: "instrument_brand",
    },
    {
      title: "Instrument",
      dataIndex: "instrument_name",
      key: "instrument_name",
    },
    {
      title: "Instrument Method",
      dataIndex: "instrument_method",
      key: "instrument_method",
    },
  ];

  const [loading, setLoading] = useState(true);

  const fetchInstrumentData = async () => {
    const { success, instrument_brand_method_list, message } = await fetchInstrumentMethods();
    if (success) {
      setDataSource(instrument_brand_method_list.map((item, i) => ({ ...item, key: i })));
    } else {
      setDataSource([]);
      toast.error(message);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchInstrumentData();
  }, []);
  return (
    <Table
      bordered
      sticky
      className="DashboardInstrumentTable"
      pagination={false}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
    />
  );
};

export default DashboardInstrumentTable;
